import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../components/apiconfig/api-config';
import {
  // Dashboard & Navigation
  FaHome, FaHistory, FaUserTie,
  
  // Reports & Analytics
  FaChartBar, FaChartLine, FaChartPie, FaFileAlt, FaFileInvoiceDollar, FaClipboardList,
  FaShip, FaShieldAlt, FaMoneyBillWave,  FaCalculator, FaExclamationTriangle,
  
  // Import & Export
  FaShippingFast, FaGlobe, FaAnchor, FaFileContract, FaPassport,
  
  // Sales & Commerce
  FaHandshake, FaShoppingCart, FaStore, FaTruck, FaClipboardCheck, FaClock,
  
  // Masters & Management
  FaIndustry,  FaSeedling, FaUserCog, FaCogs, 
  FaBriefcase, FaUserFriends, FaCreditCard, FaWater, FaCertificate,
  
  // Tickets & Support
  FaTicketAlt,
  
  // Warehouse & Storage
  FaWarehouse, FaExchangeAlt, FaBox, FaDatabase,
  
  // Navigation
  FaChevronRight, FaChevronDown, FaTimes
} from 'react-icons/fa';
import KBALLogo from '../../assets/KBAL (1).svg';
import AnchorLogo from '../../assets/anchor_1316864 1.svg';


// Custom scrollbar styles
const scrollbarStyles = `
  .custom-scrollbar,
  .custom-scrollbar * {
    scrollbar-width: thin;
  }
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb {
    border-radius: 4px;
  }
  .overflow-menu-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }
`;


// Sidebar menu structure with nested subitems
const groups = [
  {
    title: 'Reports',
    icon: <FaChartBar />,
    items: [
      { name: 'Warehouse Report Details', icon: <FaWarehouse />, path: '/report/warehouse-costing' },
      { name: 'Warehouse Report Summary', icon: <FaWarehouse />, path: '/report/warehouse-summary' },
      { name: 'Vessel Report', icon: <FaShip />, path: '/report/vessel' },
      { name: 'Commodity Report', icon: <FaSeedling />, path: '/report-commodity' },
      { name: 'Purchase', icon: <FaHandshake />, path: '/report/purchase-contract' },
      { name: 'Tracking', icon: <FaChartLine />, path: '/report/shipment-tracking' },
      { name: 'MIS Contract Report', icon: <FaClipboardList />, path: '/report/MIS-purchase' },
      // { name: 'Landing Cost Report', icon: <FaCalculator />, path: '/report/landing-cost' },
      { name: 'Sales Contract Register', icon: <FaFileContract />, path: '/report/sales' },
      { name: 'Interest Calculation Sheet', icon: <FaCalculator />, path: '/report/interest-calculation-sheet' },
      { name: 'Sales EMD', icon: <FaMoneyBillWave />, path: '/report/sales-emd-report' },
      { name: 'Sales Contract Deadline', icon: <FaChartPie />, path: '/report/sales-contract-deadline-monitor' },
      // { name: 'Sales Contract Deadline Datewise', icon: <FaChartPie />, path: '/report/sales-contract-deadline-monitor-calculator' },
      { name: 'Marine Insurance Report', icon: <FaShieldAlt />, path: '/report/marine-insurance' },
      { name: 'Payment Collection Report', icon: <FaMoneyBillWave />, path: '/payment-collection' },
      { name: 'Payment Collection MIS', icon: <FaFileInvoiceDollar />, path: '/payment-collection-mis' },
      { name: 'Sales Order Summary', icon: <FaClipboardCheck />, path: '/report/sales-order-summary' },
 
      // { name: 'Inventory', icon: <FaBoxes />, path: '/report/inventory' },
      { name: 'Combined Sales Report MIS', icon: <FaChartBar />, path: '/report/combined-sales-report-mis' },
      { name: 'Party Ledger Report', icon: <FaFileInvoiceDollar />, path: '/report/party-ledger' },
      { name: 'Negative Balance Report', icon: <FaExclamationTriangle />, path: '/report/negative-balance' },
      { name: 'Sale Broker Report', icon: <FaBriefcase />, path: '/report/sale-broker' },
    ],
  },
  // Import section
  {
    name: 'Import',
    icon: <FaGlobe />,
    subitems: [
      { name: 'Vessel Info', icon: <FaAnchor />, path: '/import-order' },
      { name: 'Bill Of Lading', icon: <FaFileContract />, path: '/bill-of-lading' },
      { name: 'Customs Clearance', icon: <FaPassport />, path: '/customs-clearance' },
      { name: 'Marine Insurance', icon: <FaShieldAlt />, path: '/import/insurance/list' },
      { name: 'Purchase Contract', icon: <FaFileContract />, path: '/purchase-contract' },
    ]
  },
  // Sales section
  {
    name: 'Sales',
    icon: <FaStore />,
    subitems: [
      { name: 'Sale Contract', icon: <FaFileContract />, path: '/sale-contract' },
      { name: 'Sales Order', icon: <FaShoppingCart />, path: '/sales-order' },
      { name: 'Delivery Order', icon: <FaTruck />, path: '/delivery-order' },
      { name: 'Delivery Extension', icon: <FaClock />, path: '/delivery-order-extension' },
      { name: 'Dispatch Entry', icon: <FaShippingFast />, path: '/dispatch-entry' },
      { name: 'Sales Contract Management Report', icon: <FaFileContract />, path: '/report/sales-contract-management', hasOverflow: true },
      { name: 'Delivery Order Management Report', icon: <FaTruck />, path: '/report/delivery-order-management', hasOverflow: true },
      { name: 'Received Payment', icon: <FaMoneyBillWave />, path: '/received-payment' },
      { name: 'Debit Note', icon: <FaFileAlt />, path: '/debit-note' },
      { name: 'Credit Note', icon: <FaFileAlt />, path: '/credit-note' },
    ]
  },
  // Masters section
  {
    name: 'Masters',
    icon: <FaCogs />,
    subitems: [
      { name: 'Supplier', icon: <FaIndustry />, path: '/supplier' },
      { name: 'Commodity', icon: <FaSeedling />, path: '/commodity' },
      // { name: 'CHA', icon: <FaBuilding />, path: '/cha' },   
      { name: 'CMA / CHA', icon: <FaUserCog />, path: '/cma' },
      { name: 'Purchase Broker', icon: <FaHandshake />, path: '/purchase-broker' },
      { name: 'Sale Broker', icon: <FaBriefcase />, path: '/broker' },
      { name: 'Document', icon: <FaFileAlt />, path: '/document' },
      { name: 'High Seas Agreement', icon: <FaWater />, path: '/high-seas-agreement' },
      { name: 'Issuing Authorities', icon: <FaCertificate />, path: '/issuing-authorities' },
      { name: 'Payment', icon: <FaCreditCard />, path: '/payment' },
     
      { name: 'Kribhco', icon: <FaIndustry />, path: '/kribhco' },
      { name: 'Domestic Buyer', icon: <FaUserFriends />, path: '/domestic-buyer' },
      { name: 'Cost Breakup', icon: <FaCalculator />, path: '/cost-breakup' },
    ],
  },
  // Warehouse section
  {
    name: 'Warehouse',
    icon: <FaWarehouse />,
    subitems: [
      { name: 'Warehouse Entry', icon: <FaBox />, path: '/warehouse-entry' },
      { name: 'Warehouse Transfer', icon: <FaExchangeAlt />, path: '/warehouse-transfer' },
      
    ],
  },
];


const MAX_RECENT_ITEMS = 3;


const Sidebar = ({ open, onClose, isMobile }) => {
  const location = useLocation();
  // Change collapsed to openGroup (string or null)
  const [openGroup, setOpenGroup] = useState(null);
  const [recentItems, setRecentItems] = useState([]);
  const [userRole, setUserRole] = useState('');


  // Helper function to check if a path is active
  const isPathActive = useCallback((path) => {
    if (!path) return false;
    // Exact match
    if (location.pathname === path) return true;
    // For nested routes, check if current path starts with the item path and the next character is '/' or end of string
    if (location.pathname.startsWith(path)) {
      const nextChar = location.pathname.charAt(path.length);
      return nextChar === '/' || nextChar === '' || nextChar === '?';
    }
    return false;
  }, [location.pathname]);


  // Track recently visited pages
  useEffect(() => {
    if (location.pathname === '/dashboard') return; // Don't track dashboard
    
    // Find the current page in all menu items
    let currentPage = null;
    for (const group of groups) {
      const items = group.items || group.subitems || [];
      for (const item of items) {
        if (isPathActive(item.path)) {
          currentPage = item;
          break;
        }
        if (item.subitems) {
          const subItem = item.subitems.find(sub => isPathActive(sub.path));
          if (subItem) {
            currentPage = subItem;
            break;
          }
        }
      }
      if (currentPage) break;
    }


    if (currentPage) {
      setRecentItems(prev => {
        // Remove if already exists
        const filtered = prev.filter(item => item.path !== currentPage.path);
        // Add to beginning
        const updated = [currentPage, ...filtered];
        // Limit to max items
        return updated.slice(0, MAX_RECENT_ITEMS);
      });
    }
  }, [location.pathname, isPathActive]);

  // Fetch user role from API on component mount
  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/profile/profile-get`,
          { withCredentials: true }
        );
        if (response.data.success) {
          setUserRole(response.data.data.role);
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
      }
    };
    fetchUserRole();
  }, []);

  // Helper to toggle collapse for any menu (only one open at a time)
  const handleCollapse = (key) => {
    setOpenGroup((prev) => (prev === key ? null : key));
  };


  // Recursive menu renderer for subitems
  const renderMenuItems = (items, parentKey = '', isSubitem = false, hideIcons = false, groupName = '') => (
    <ul className={`flex flex-col gap-0.5 transition-all duration-200 ${open ? (isSubitem ? 'pl-0' : 'pl-2') : 'items-center'}`}>
      {items.map((item) => {
        const hasSubitems = !!item.subitems;
        const key = parentKey + item.name;
        const isActive = isPathActive(item.path);
        // For Import and Sales subitems, show icon only when sidebar is closed
        const isImportOrSales = ['Import', 'Sales'].includes(groupName);
        const showIcon = hasSubitems
          ? (!isSubitem && !hideIcons && (!isImportOrSales || open)) || (!open)
          : (!open || (!isSubitem && !hideIcons && (!isImportOrSales || open)));
        const subitemHideIcons = hideIcons || isImportOrSales;
        
        // Check if this item should have overflow styling
        const shouldHaveOverflow = item.hasOverflow;
        
        return (
          <li key={key} className="w-full">
            {hasSubitems ? (
              <>
                <button
                  className={`flex items-center w-full ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0`}
                  onClick={() => handleCollapse(key)}
                  type="button"
                >
                  {showIcon && <span className="text-lg flex items-center justify-center w-6 h-6">{item.icon}</span>}
                  <span className={`transition-all duration-200 ${open ? 'opacity-100 ml-2 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>{item.name}</span>
                  {open && (
                    <span className="ml-auto">
                      {openGroup === key ? <FaChevronDown className="text-xs" /> : <FaChevronRight className="text-xs" />}
                    </span>
                  )}
                </button>
                {/* Animated submenu */}
                <div
                  className={`transition-all duration-300 ${openGroup === key ? 'max-h-[500px] opacity-100 overflow-y-auto custom-scrollbar' : 'max-h-0 opacity-0 overflow-hidden'}`}
                  style={{ maxHeight: openGroup === key ? '500px' : '0', opacity: openGroup === key ? 1 : 0 }}
                >
                  {renderMenuItems(item.subitems, key, true, subitemHideIcons, groupName || item.name)}
                </div>
              </>
            ) : (
              <Link
                to={item.path}
                className={`flex items-center ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0 ${isActive ? 'bg-sky-100 text-sky-700 font-semibold' : ''} ${shouldHaveOverflow ? 'overflow-menu-item' : ''}`}
                style={isActive ? { borderRight: '3px solid #3899cf', background: '#e0f2fe' } : {}}
                onClick={() => {
                  // Close sidebar on mobile when item is clicked
                  if (isMobile) {
                    onClose();
                  }
                }}
                title={shouldHaveOverflow && open ? item.name : undefined}
              >
                {isImportOrSales && open
                  ? <span className="inline-block w-6 flex-shrink-0" />
                  : showIcon
                    ? <span className="text-lg flex items-center justify-center w-6 h-6 flex-shrink-0">{item.icon}</span>
                    : <span className="inline-block w-6 flex-shrink-0" />}
                <span 
                  className={`transition-all duration-200 ${open ? 'ml-2 opacity-100 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'} ${shouldHaveOverflow ? 'overflow-hidden text-ellipsis whitespace-nowrap' : ''}`} 
                  style={{ 
                    whiteSpace: shouldHaveOverflow ? 'nowrap' : 'nowrap',
                    maxWidth: shouldHaveOverflow && open ? 'calc(100% - 2rem)' : 'auto'
                  }}
                >
                  {item.name}
                </span>
              </Link>
            )}
          </li>
        );
      })}
    </ul>
  );


  return (
    <>
      <style>{scrollbarStyles}</style>
      
      {/* Mobile overlay */}
      {open && isMobile && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={onClose}
        />
      )}
      
      <aside
        className={`h-screen fixed left-0 top-0 z-30 transition-all duration-200 bg-white border-r border-gray-200 shadow-sm flex flex-col no-print ${
          open ? 'w-64' : 'w-20'
        } ${isMobile ? (open ? 'translate-x-0' : '-translate-x-full') : ''}`}
        style={{ scrollbarGutter: 'stable' }}
      >
      {/* Logo Section */}
      <div className={`flex items-center justify-between flex-shrink-0 relative ${open ? 'px-4' : 'px-2'}`}>
        <button
          onClick={onClose}
          className="flex items-start justify-start hover:opacity-80 transition-opacity duration-200"
          title="Close Sidebar"
        >
          {open ? (
            <img 
              src={KBALLogo} 
              alt="KBAL Logo" 
              className="h-16 w-auto max-w-full" 
              style={{ 
                imageRendering: 'crisp-edges',
                shapeRendering: 'crispEdges',
                textRendering: 'optimizeLegibility'
              }}
            />
          ) : (
            <img 
              src={AnchorLogo} 
              alt="Anchor Logo" 
              className="h-12 ml-3 mb-2 p-1 w-auto" 
              style={{ 
                imageRendering: 'crisp-edges',
                shapeRendering: 'crispEdges',
                textRendering: 'optimizeLegibility'
              }}
            />
          )}
        </button>
        
        {/* Mobile close button */}
        {open && isMobile && (
          <button
            onClick={onClose}
            className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition-colors"
            title="Close Sidebar"
          >
            <FaTimes className="text-gray-600 text-lg" />
          </button>
        )}
      </div>
      
     
      
      {/* Dashboard Link - Hide for backup role */}
      {userRole !== 'backup' && (
        <div className="border-t border-b border-gray-100 py-2">
          <div className="px-2 py-2 h-12 flex items-center">
            <Link
              to="/dashboard"
              className={`flex items-center w-full ${open ? 'gap-2 px-3' : 'justify-center'} rounded-sm transition-colors font-normal text-gray-700 hover:bg-sky-50 hover:text-sky-700 h-10 ${location.pathname === '/dashboard' ? 'bg-sky-50 text-sky-700' : ''}`}
              style={location.pathname === '/dashboard' ? { borderRight: '4px solid #3899cf', background: '#f0f9ff' } : {}}
              onClick={() => {
                // Close sidebar on mobile when dashboard is clicked
                if (isMobile) {
                  onClose();
                }
              }}
            >
              <span className="text-lg flex items-center justify-center w-6 h-6">
                <FaHome />
              </span>
              <span className={`transition-all duration-200 ${open ? 'opacity-100 ml-2 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>Dashboard</span>
            </Link>
          </div>
        </div>
      )}
      
      {/* Recent Section - Hide for backup role */}
      {userRole !== 'backup' && recentItems.length > 0 && (
        <div className="border-t border-b border-gray-100 py-2">
          <div className="px-2">
            <button
              className={`flex items-center w-full ${open ? 'gap-2 px-3' : 'justify-center'} rounded-sm transition-colors font-normal text-gray-700 hover:bg-sky-50 hover:text-sky-700 h-10`}
              onClick={() => handleCollapse('recent')}
              type="button"
            >
              <span className="text-lg flex items-center justify-center w-6 h-6">
                <FaHistory />
              </span>
              <span className={`transition-all duration-200 ${open ? 'opacity-100 ml-2 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>Recent</span>
              {open && (
                <span className="ml-auto">
                  {openGroup === 'recent' ? <FaChevronDown className="text-xs" /> : <FaChevronRight className="text-xs" />}
                </span>
              )}
            </button>
            
            {/* Animated submenu for Recent items */}
            <div
              className={`transition-all duration-300 ${openGroup === 'recent' ? 'max-h-[500px] opacity-100 overflow-y-auto custom-scrollbar' : 'max-h-0 opacity-0 overflow-hidden'}`}
              style={{ maxHeight: openGroup === 'recent' ? '500px' : '0', opacity: openGroup === 'recent' ? 1 : 0 }}
            >
              <ul className={`flex flex-col gap-0.5 transition-all duration-200 ${open ? 'pl-2' : 'items-center'}`}>
                {recentItems.map((item, index) => (
                  <li key={`recent-${index}`} className="w-full">
                    <Link
                      to={item.path}
                      className={`flex items-center ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0 ${isPathActive(item.path) ? 'bg-sky-100 text-sky-700 font-semibold' : ''}`}
                      style={isPathActive(item.path) ? { borderRight: '3px solid #3899cf', background: '#e0f2fe' } : {}}
                      onClick={() => {
                        // Close sidebar on mobile when item is clicked
                        if (isMobile) {
                          onClose();
                        }
                      }}
                    >
                      {!open ? (
                        <span className="text-lg flex items-center justify-center w-6 h-6">{item.icon}</span>
                      ) : (
                        <>
                          <span className="inline-block w-6" />
                          <span className="ml-2 opacity-100 text-sm font-medium" style={{ whiteSpace: 'nowrap' }}>{item.name}</span>
                        </>
                      )}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      
             {/* Scrollable Menu Section */}
       <div className="flex-1 overflow-y-auto custom-scrollbar" style={{ scrollbarGutter: 'stable', scrollbarWidth: 'none' }}>
         <div className="flex flex-col gap-1 px-2 pb-20">
           {/* Statewise Commodity Report - Top Level - Hide for backup role */}
           {userRole !== 'backup' && (
             <Link
               to="/report/statewise-commodity"
               className={`flex items-center ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0 ${location.pathname === '/report/statewise-commodity' ? 'bg-sky-100 text-sky-700 font-semibold' : ''}`}
               style={location.pathname === '/report/statewise-commodity' ? { borderRight: '3px solid #3899cf', background: '#e0f2fe' } : {}}
               onClick={() => {
                 // Close sidebar on mobile when item is clicked
                 if (isMobile) {
                   onClose();
                 }
               }}
             >
               <span className="text-lg flex items-center justify-center w-6 h-6"><FaChartPie /></span>
               <span className={`transition-all duration-200 ${open ? 'ml-2 opacity-100 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>Import Sheet</span>
             </Link>
           )}
            {/* Import Sheet Summary - New Link */}
           {userRole !== 'backup' && (
             <Link
               to="/import-sheet-summary"
               className={`flex items-center ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0 ${location.pathname === '/import-sheet-summary' ? 'bg-sky-100 text-sky-700 font-semibold' : ''}`}
               style={location.pathname === '/import-sheet-summary' ? { borderRight: '3px solid #3899cf', background: '#e0f2fe' } : {}}
               onClick={() => {
                 if (isMobile) {
                   onClose();
                 }
               }}
             >
               <span className="text-lg flex items-center justify-center w-6 h-6"><FaChartPie /></span>
               <span className={`transition-all duration-200 ${open ? 'ml-2 opacity-100 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>Import Sheet Summary</span>
             </Link>
           )}
            {/* Stock Adjustment Note - New Link */}
            {userRole !== 'backup' && (
              <Link
                to="/san"
                className={`flex items-center ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0 ${location.pathname.startsWith('/san') ? 'bg-sky-100 text-sky-700 font-semibold' : ''}`}
                style={location.pathname.startsWith('/san') ? { borderRight: '3px solid #3899cf', background: '#e0f2fe' } : {}}
                onClick={() => {
                  if (isMobile) {
                    onClose();
                  }
                }}
              >
                <span className="text-lg flex items-center justify-center w-6 h-6"><FaChartPie /></span>
                <span className={`transition-all duration-200 ${open ? 'ml-2 opacity-100 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>Stock Adjustment Note (SAN)</span>
              </Link>
            )}
           {groups.map((group) => (
            group.subitems || group.items ? (
              <div key={group.name || group.title} className="w-full">
                {/* Hide all menu groups for backup role */}
                {userRole !== 'backup' && (
                  <>
                    <button
                      className={`flex items-center w-full ${open ? 'gap-2 px-3' : 'justify-center'} rounded-sm transition-colors font-normal text-gray-700 hover:bg-sky-50 hover:text-sky-700 h-10`}
                      onClick={() => handleCollapse(group.name || group.title)}
                      type="button"
                    >
                      <span className="text-lg flex items-center justify-center w-6 h-6">{group.icon}</span>
                      <span className={`transition-all duration-200 ${open ? 'opacity-100 ml-2 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>{group.name || group.title}</span>
                      {open && (
                        <span className="ml-auto">
                          {openGroup === (group.name || group.title) ? <FaChevronDown className="text-xs" /> : <FaChevronRight className="text-xs" />}
                        </span>
                      )}
                    </button>
                    {/* Animated submenu */}
                    <div
                      className={`transition-all duration-300 ${openGroup === (group.name || group.title) ? 'max-h-[500px] opacity-100 overflow-y-auto custom-scrollbar' : 'max-h-0 opacity-0 overflow-hidden'}`}
                      style={{ maxHeight: openGroup === (group.name || group.title) ? '500px' : '0', opacity: openGroup === (group.name || group.title) ? 1 : 0 }}
                    >
                      {/* For Reports, Masters, and Warehouse groups, hide icons for their items */}
                      {(group.items || group.subitems) &&
                        (['Reports', 'Masters', 'Warehouse'].includes(group.name || group.title)
                          ? renderMenuItems(group.items || group.subitems, group.name || group.title, false, true, group.name || group.title)
                          : renderMenuItems(group.items || group.subitems, group.name || group.title, false, false, group.name || group.title)
                        )}
                    </div>
                  </>
                )}
              </div>
            ) : null
          ))}
          {/* User List link - Only visible to admin role (Hide for backup role) */}
          {userRole === 'admin' && userRole !== 'backup' && (
            <Link
              to="/user-list"
              className={`flex items-center ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0 ${location.pathname === '/user-list' ? 'bg-sky-100 text-sky-700 font-semibold' : ''}`}
              style={location.pathname === '/user-list' ? { borderRight: '3px solid #3899cf', background: '#e0f2fe' } : {}}
              onClick={() => {
                // Close sidebar on mobile when item is clicked
                if (isMobile) {
                  onClose();
                }
              }}
            >
              <span className="text-lg flex items-center justify-center w-6 h-6"><FaUserTie /></span>
              <span className={`transition-all duration-200 ${open ? 'ml-2 opacity-100 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>User List</span>
            </Link>
          )}
         {/* Backup Management link - Visible to all roles except backup gets only this */}
         {userRole !== 'backup' && (
           <Link
             to="/backup-management"
             className={`flex items-center ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0 ${location.pathname === '/backup-management' ? 'bg-sky-100 text-sky-700 font-semibold' : ''}`}
             style={location.pathname === '/backup-management' ? { borderRight: '3px solid #3899cf', background: '#e0f2fe' } : {}}
             onClick={() => {
               // Close sidebar on mobile when item is clicked
               if (isMobile) {
                 onClose();
               }
             }}
           >
             <span className="text-lg flex items-center justify-center w-6 h-6"><FaDatabase /></span>
             <span className={`transition-all duration-200 ${open ? 'ml-2 opacity-100 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>Backup Management</span>
           </Link>
         )}
         {/* Ticket List link - Visible to all users */}
         <Link
           to="/ticket-list"
           className={`flex items-center ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0 ${location.pathname === '/ticket-list' || location.pathname === '/ticket-raise' ? 'bg-sky-100 text-sky-700 font-semibold' : ''}`}
           style={location.pathname === '/ticket-list' || location.pathname === '/ticket-raise' ? { borderRight: '3px solid #3899cf', background: '#e0f2fe' } : {}}
           onClick={() => {
             // Close sidebar on mobile when item is clicked
             if (isMobile) {
               onClose();
             }
           }}
         >
           <span className="text-lg flex items-center justify-center w-6 h-6"><FaTicketAlt /></span>
           <span className={`transition-all duration-200 ${open ? 'ml-2 opacity-100 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>Ticket Raise</span>
         </Link>

         {/* Backup Management link - Only for backup role (they see only this) */}
         {userRole === 'backup' && (
           <Link
             to="/backup-management"
             className={`flex items-center ${open ? 'gap-2 px-2' : 'justify-center'} rounded transition-colors font-medium text-gray-700 hover:bg-sky-100 hover:text-sky-700 h-9 min-h-0 ${location.pathname === '/backup-management' ? 'bg-sky-100 text-sky-700 font-semibold' : ''}`}
             style={location.pathname === '/backup-management' ? { borderRight: '3px solid #3899cf', background: '#e0f2fe' } : {}}
             onClick={() => {
               // Close sidebar on mobile when item is clicked
               if (isMobile) {
                 onClose();
               }
             }}
           >
             <span className="text-lg flex items-center justify-center w-6 h-6"><FaDatabase /></span>
             <span className={`transition-all duration-200 ${open ? 'ml-2 opacity-100 text-sm font-medium' : 'opacity-0 w-0 overflow-hidden'}`} style={{ whiteSpace: 'nowrap' }}>Backup Management</span>
           </Link>
         )}
        </div>
      </div>
      </aside>
    </>
  );
};


export default Sidebar;
